/* @todo: all this class' functions and variables are temporary, as API is not ready */
import { IProduct } from '../domain/IProduct'
import { IProductRepository } from '../domain/IProductRepository'

export class ProductRepository implements IProductRepository {
  private dummyProduct: Omit<IProduct, 'ean'> = {
    brand: 'Ipsum',
    category: 'Lorem ipsum',
    createdDate: '2021-01-06T23:00:00.000Z',
    deliveryTime: '3 à 5 jours',
    image: 'http://via.placeholder.com/240x240?text=Image',
    mixed: true,
    name: 'Pot en plastique Roméo Rond Griotte Ø 40 cm',
    nomenclature: 'Lorem ipsum dolor',
    packaging: 'Ipsum',
    promotions: ['promo 1'],
    published: true,
    sku: '5670098789090',
    subcategory: 'Lorem ipsum',
    supplier: 'Lorem',
  }

  async getProductBySku(sku: string): Promise<IProduct> {
    try {
      const output = { ...this.dummyProduct, ean: sku, sku }
      return output
    } catch (message) {
      throw new Error(message)
    }
  }

  async listProducts(): Promise<IProduct[]> {
    try {
      const output = [...Array(9)].map((item, index) => {
        const { sku: defaultSku, ...rest } = this.dummyProduct
        const sku = `${parseInt(defaultSku, 10) + index * index}`
        return { ...rest, ean: sku, sku }
      })
      return output
    } catch (message) {
      throw new Error(message)
    }
  }
}
